import {useMagnoliaContext} from "../composables/use-magnolia-context";

export default defineNuxtPlugin((nuxt) => {
    nuxt.vueApp.directive('cms-edit', {
        mounted: (el: Element) => {
          const context = useMagnoliaContext();
          if (context.isMagnoliaEdit) {
            el.setAttribute('cms:edit', '')
          }
        },
        getSSRProps(binding, vnode) {
            return {}
        },

    })
})
